import React, { useMemo, useEffect, useCallback, createContext } from "react";
import AxiosTokenHelper from "../Utils/Helpers/AxiosTokenHelper";
import UseAsync from "../Utils/Auth/UseAsync";

type AuthProviderProps = {
  children: React.ReactNode;
};

const localStorageKey = "gb_storage_key";

const AuthContext = createContext(null!);

const bootstrapAppData = async () => {
  let responseData = {};

  const token = localStorage.getItem(localStorageKey);

  if (token) {
    const resp = await AxiosTokenHelper().get(`/api/v1/token_users`, {
      crossDomain: true,
    });
    responseData = resp.data.success
      ? resp.data.user_data
      : { logged_in: false };
  }

  return responseData;
};

function AuthProvider({ children }: AuthProviderProps) {
  const { data, run, setData } = UseAsync();

  useEffect(() => {
    const appDataPromise = bootstrapAppData();
    run(appDataPromise);
  }, [run]);

  const authenticate = useCallback(() => {
    AxiosTokenHelper()
      .get(`/api/v1/token_users`, { crossDomain: true })
      .then((resp) => {
        setData(resp.data.success ? resp.data.user_data : { logged_in: false });
      });
  }, [setData]);

  const setAccount = useCallback(
    (resp: any) => {
      let newData = data;
      newData.account = resp;
      setData(newData);
    },
    [data, setData]
  );

  const logout = useCallback(() => {
    localStorage.removeItem(localStorageKey);
    setData({ logged_in: false });
  }, [setData]);

  const value = useMemo(
    () => ({
      ...data,
      authenticate,
      setAccount,
      logout,
    }),
    [data, authenticate, setAccount, logout]
  );

  return (
    // @ts-ignore
    <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
  );
}

const AuthConsumer = AuthContext.Consumer;

export { AuthProvider, AuthConsumer, AuthContext, localStorageKey };
